import PropTypes from 'prop-types'
import React,{ useState} from 'react'
import { useDrop } from '../contexts/DropContext'
import {FaStickyNote} from "react-icons/fa"
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip as ReactTooltip} from "react-tooltip"


const NoteButton = ({notes, sessionID, color, loadStatus }) => {
  const [buttonState, changeButtonState] = useState(true)
  const buttonClick = () => {
    changeButtonState(sessionID)    
    loadStatus(notes, sessionID)
  }
 
  return (
    <button
      onClick={buttonClick}
      style={{
        backgroundColor: color,
        width: '40px',
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
      className='btn'
      id = {sessionID + "note"}
      data-tooltip-content = "View and Edit Notes"
    >
      <div style={{ justifyContent: "center" }}>
      <FaStickyNote/>
      <ReactTooltip anchorId={sessionID + 'note'}/>
      </div>
    </button>
  )
}


NoteButton.defaultProps = {
  color: 'steelblue',
  sessionID: 837360280,
}

NoteButton.propTypes = { 
  sessionID: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
}

export default NoteButton